// Shared state for the header filter bar (client search + timeframe).
//
// There is ONE HeaderFilterPills in the layout, rendered on every page. Pages
// that filter a list (headerFilter: 'list' in route meta) read these values
// instead of owning their own refs — so the bar and the page can never drift,
// and there is no "layout fallback vs page copy" to reconcile.
//
// The portfolio pill drives the global portfolio store directly, so it is not
// duplicated here.
export const useHeaderFilters = () => {
  // useState = SSR-safe singleton, shared across the layout and every page.
  const clientQuery = useState('header-client-query', () => '')
  const timeframe = useState('header-timeframe', () => 90)
  return { clientQuery, timeframe }
}
